<template>
  <div class="reviews-container" id="slider">
    <div class="reviews-main-header">{{ $t('reviews.main-header') }}</div>
    <div class="reviews-small-header">{{ $t('reviews.small-header') }}</div>
    <Slider />
    <myForm />
    <Footer />
    <CookieBanner v-if="showCookieBanner"/>
  </div>
</template>

<script>
import Slider from "./Slider.vue";
import myForm from "./myForm.vue";
import Footer from "./Footer.vue";
import CookieBanner from "./CookieBanner.vue";

export default {
  name: "reviews-container",
  components: {
    Slider,
    myForm,
    Footer,
    CookieBanner,
  },
  data: () => ({
    showCookieBanner: true,
  }),
  methods: {
    handleAgree() {
      sessionStorage.setItem("allowCookie", true);
      this.showCookieBanner = false;
    },
  },
  created() {
    if (sessionStorage.getItem("allowCookie")) {
      this.handleAgree();
    }
  },
};
</script>

<style scoped lang="scss">
.reviews-container {
  background-image: url("../assets/img/reviews-back.svg");
  min-height: 500px;
  width: 100vw;
  background-repeat: no-repeat;
  background-position-x: 97%;
  background-size: cover;
  // @media screen and (max-width: 768px) {
  //   background-image: url("../assets/img/review-back-768.svg");
  // }

  //   @media screen and (max-width: 480px) {
  //   // background-image: url("../assets/img/rewievs-back-480.svg");
  //   background-position-x: 95%;
  // }
}

.reviews-main-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 60px;
  line-height: 100%;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
  padding-top: 170px;


  @media screen and (max-width: 1130px) {
    padding-top: 150px;
  }

  @media screen and (max-width: 1012px) {
    padding-top: 120px;
    font-size: 48px;
  }

  @media screen and (max-width: 767px) {
    // font-size: 56px;
    line-height: 100%;
    margin-bottom: 2px;
  }
  @media screen and (max-width: 479px) {
    font-size: 44px;

  }
}

.reviews-small-header {
  font-family: Roboto;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 100%;
  /* identical to box height, or 24px */

  text-align: center;
  text-transform: uppercase;

  color: #ffffff;
  padding-bottom: 110px;

   @media screen and (max-width: 1130px) {
    padding-bottom: 80px;
  }

  @media screen and (max-width: 1020px) {
    padding-bottom: 70px;
    font-size: 20px;
  }

  @media screen and (max-width: 767px) {
    font-size: 18px;
    line-height: 100%;
    padding-bottom: 50px;
  }
  @media screen and (max-width: 479px) {
    font-size: 16px;
  }
}
</style>
